import { Component, Input } from '@angular/core';
import { interval, Subscription, takeWhile, timer } from 'rxjs';

@Component({
    selector: 'app-network-banner',
    standalone: true,
    imports: [],
    templateUrl: './network-banner.component.html',
    styleUrl: './network-banner.component.scss',
})
export class NetworkBannerComponent {
    @Input() isOnline: boolean = true;
    showRetryButton: boolean = false;
    isRetrying: boolean = false;
    countdown: number = 10;
    private countdownSubscription?: Subscription;
    private retryButtonTimer?: Subscription;

    ngOnChanges() {
        if (!this.isOnline) {
            this.startCountdown();
            // Show retry button after 10 seconds
            this.retryButtonTimer = timer(10000).subscribe(() => {
                if (!this.isOnline) {
                    this.showRetryButton = true;
                    this.stopCountdown();
                }
            });
        } else {
            this.showRetryButton = false;
            this.stopCountdown();
            this.retryButtonTimer?.unsubscribe();
        }
    }

    private startCountdown() {
        this.stopCountdown(); // Clear any existing countdown

        // Start with 5 seconds
        this.countdown = 10;

        // Create a timer that ticks every second
        this.countdownSubscription = interval(1000)
            .pipe(
                takeWhile(() => !this.showRetryButton), // Stop when retry button shows
            )
            .subscribe(() => {
                this.countdown--;
                if (this.countdown === 0) {
                    // Reset to 10 when it reaches 0
                    this.countdown = 10;
                }
            });
    }

    private stopCountdown() {
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
            this.countdownSubscription = undefined;
        }
        this.countdown = 10;
    }

    async retryConnection() {
        if (!this.isOnline) {
            this.isRetrying = true;

            // Wait for 1 second before reverting back to "Retry Now"
            setTimeout(() => {
                this.isRetrying = false;
            }, 1000);

            return;
        }
        window.location.reload();
    }

    ngOnDestroy() {
        this.stopCountdown();
        this.retryButtonTimer?.unsubscribe();
    }
}
